// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: 2gDnF9pNr9p
import * as React from "react";
import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";
import {
  hasVariant,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import SelectCountry from "../../SelectCountry"; // plasmic-import: DRLS9kjJ501/component
import SelectState from "../../SelectState"; // plasmic-import: EbL1EK3L-GE/component
import { useScreenVariants as useScreenVariantsnoO6HAIuEe } from "./PlasmicGlobalVariant__Screen"; // plasmic-import: NoO6H-AIuEE/globalVariant
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicOnboardingOwnerDetailsRetry.module.css"; // plasmic-import: 2gDnF9pNr9p/css
import ChecksvgIcon from "./icons/PlasmicIcon__Checksvg"; // plasmic-import: YS4jDAKGMbE/icon
import DividerLineVerticalIcon from "./icons/PlasmicIcon__DividerLineVertical"; // plasmic-import: Ql4i0eZ6cYO/icon

createPlasmicElementProxy;

export const PlasmicOnboardingOwnerDetailsRetry__VariantProps = new Array();

export const PlasmicOnboardingOwnerDetailsRetry__ArgProps = new Array(
  "ownerText"
);

const $$ = {};

function PlasmicOnboardingOwnerDetailsRetry__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = p.useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "countrySelect.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "selectState.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const globalVariants = ensureGlobalVariants({
    screen: useScreenVariantsnoO6HAIuEe()
  });
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div className={classNames(projectcss.all, sty.freeBox__pZbeA)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__sNaLc
              )}
            >
              {"Account Information"}
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__goSoz)}>
            <div className={classNames(projectcss.all, sty.freeBox__e0Rjz)}>
              <div
                data-plasmic-name={"lineStack"}
                data-plasmic-override={overrides.lineStack}
                className={classNames(projectcss.all, sty.lineStack)}
              >
                <div
                  data-plasmic-name={"circle"}
                  data-plasmic-override={overrides.circle}
                  className={classNames(projectcss.all, sty.circle)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__dr8NT)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__rSoc0)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___2XFn)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle2"}
                  data-plasmic-override={overrides.circle2}
                  className={classNames(projectcss.all, sty.circle2)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__pwCwn)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg___702GQ)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__ewy4M)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle3"}
                  data-plasmic-override={overrides.circle3}
                  className={classNames(projectcss.all, sty.circle3)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__u0Qb)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__wmWgw)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__sg5I)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle4"}
                  data-plasmic-override={overrides.circle4}
                  className={classNames(projectcss.all, sty.circle4)}
                >
                  <ChecksvgIcon
                    className={classNames(projectcss.all, sty.svg__p1Dx6)}
                    role={"img"}
                  />
                </div>
                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__w4Sm7)}
                  role={"img"}
                />

                <DividerLineVerticalIcon
                  className={classNames(projectcss.all, sty.svg__hfhld)}
                  role={"img"}
                />

                <div
                  data-plasmic-name={"circle5"}
                  data-plasmic-override={overrides.circle5}
                  className={classNames(projectcss.all, sty.circle5)}
                />
              </div>
            </div>
            <p.Stack
              as={"div"}
              hasGap={true}
              className={classNames(projectcss.all, sty.freeBox__rg6CQ)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___7Khqf
                )}
              >
                {"Setup Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hBnr
                )}
              >
                {"Business Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wjqz
                )}
              >
                {"Ownership"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__bgu5U
                )}
              >
                {"Banking Details"}
              </div>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lv71U
                )}
              >
                {"Retry & Submit"}
              </div>
            </p.Stack>
            <div className={classNames(projectcss.all, sty.freeBox__uc2Ab)}>
              <div className={classNames(projectcss.all, sty.freeBox__tgUm)}>
                {p.renderPlasmicSlot({
                  defaultContents:
                    "The owner Sean O'Brien wasn't immediately verified by our compliance team. Please try again by re-entering their information below:",
                  value: args.ownerText,
                  className: classNames(sty.slotTargetOwnerText)
                })}
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__m0Jc6)}>
                <div className={classNames(projectcss.all, sty.freeBox__ww6Jy)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text___4NQe7
                    )}
                  >
                    {"First Name"}
                  </div>
                  <input
                    data-plasmic-name={"firstName"}
                    data-plasmic-override={overrides.firstName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.firstName
                    )}
                    placeholder={"First"}
                    ref={ref => {
                      $refs["firstName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__fcbaW)}>
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__x3Qr
                    )}
                  >
                    {"Last Name"}
                  </div>
                  <input
                    data-plasmic-name={"lastName"}
                    data-plasmic-override={overrides.lastName}
                    className={classNames(
                      projectcss.all,
                      projectcss.input,
                      sty.lastName
                    )}
                    placeholder={"Last"}
                    ref={ref => {
                      $refs["lastName"] = ref;
                    }}
                    size={1}
                    type={"text"}
                    value={""}
                  />
                </div>
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__dsZsj)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__bfT5
                  )}
                >
                  {"Address"}
                </div>
                <SelectCountry
                  data-plasmic-name={"countrySelect"}
                  data-plasmic-override={overrides.countrySelect}
                  className={classNames("__wab_instance", sty.countrySelect)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "countrySelect",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"Country"}
                  value={p.generateStateValueProp($state, [
                    "countrySelect",
                    "value"
                  ])}
                />

                <input
                  data-plasmic-name={"address1"}
                  data-plasmic-override={overrides.address1}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.address1
                  )}
                  placeholder={"Address Line 1"}
                  ref={ref => {
                    $refs["address1"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <input
                  data-plasmic-name={"city"}
                  data-plasmic-override={overrides.city}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.city
                  )}
                  placeholder={"City"}
                  ref={ref => {
                    $refs["city"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />

                <SelectState
                  data-plasmic-name={"selectState"}
                  data-plasmic-override={overrides.selectState}
                  className={classNames("__wab_instance", sty.selectState)}
                  onChange={(...eventArgs) => {
                    p.generateStateOnChangeProp($state, [
                      "selectState",
                      "value"
                    ])(eventArgs[0]);
                  }}
                  placeholder={"State"}
                  value={p.generateStateValueProp($state, [
                    "selectState",
                    "value"
                  ])}
                />

                <input
                  data-plasmic-name={"zip"}
                  data-plasmic-override={overrides.zip}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.zip
                  )}
                  placeholder={"ZIP"}
                  ref={ref => {
                    $refs["zip"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div className={classNames(projectcss.all, sty.freeBox__erZuC)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__t5I8
                  )}
                >
                  {"Date of Birth"}
                </div>
                <div
                  data-plasmic-name={"dob"}
                  data-plasmic-override={overrides.dob}
                  className={classNames(projectcss.all, sty.dob)}
                />
              </div>
              <div
                data-plasmic-name={"ssnStack"}
                data-plasmic-override={overrides.ssnStack}
                className={classNames(projectcss.all, sty.ssnStack)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__pqG5Y
                  )}
                >
                  {"Social Security Number"}
                </div>
                <input
                  data-plasmic-name={"ssn"}
                  data-plasmic-override={overrides.ssn}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.ssn
                  )}
                  placeholder={"123-45-6789"}
                  ref={ref => {
                    $refs["ssn"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div
                data-plasmic-name={"passportStack"}
                data-plasmic-override={overrides.passportStack}
                className={classNames(projectcss.all, sty.passportStack)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__sayCd
                  )}
                >
                  {"Passport Number"}
                </div>
                <input
                  data-plasmic-name={"passport"}
                  data-plasmic-override={overrides.passport}
                  className={classNames(
                    projectcss.all,
                    projectcss.input,
                    sty.passport
                  )}
                  placeholder={""}
                  ref={ref => {
                    $refs["passport"] = ref;
                  }}
                  size={1}
                  type={"text"}
                  value={""}
                />
              </div>
              <div
                data-plasmic-name={"errorText"}
                data-plasmic-override={overrides.errorText}
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.errorText
                )}
              >
                {hasVariant(globalVariants, "screen", "small") ? (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Incorrect email or password"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={"plasmic_default__all plasmic_default__span"}
                      style={{ color: "#FF0000" }}
                    >
                      {"Must complete all required fields"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"continueButton"}
                data-plasmic-override={overrides.continueButton}
                className={classNames(projectcss.all, sty.continueButton)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__ogEtJ
                  )}
                >
                  {"Submit"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5",
    "firstName",
    "lastName",
    "countrySelect",
    "address1",
    "city",
    "selectState",
    "zip",
    "dob",
    "ssnStack",
    "ssn",
    "passportStack",
    "passport",
    "errorText",
    "continueButton"
  ],

  lineStack: [
    "lineStack",
    "circle",
    "circle2",
    "circle3",
    "circle4",
    "circle5"
  ],

  circle: ["circle"],
  circle2: ["circle2"],
  circle3: ["circle3"],
  circle4: ["circle4"],
  circle5: ["circle5"],
  firstName: ["firstName"],
  lastName: ["lastName"],
  countrySelect: ["countrySelect"],
  address1: ["address1"],
  city: ["city"],
  selectState: ["selectState"],
  zip: ["zip"],
  dob: ["dob"],
  ssnStack: ["ssnStack", "ssn"],
  ssn: ["ssn"],
  passportStack: ["passportStack", "passport"],
  passport: ["passport"],
  errorText: ["errorText"],
  continueButton: ["continueButton"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicOnboardingOwnerDetailsRetry__ArgProps,
          internalVariantPropNames:
            PlasmicOnboardingOwnerDetailsRetry__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicOnboardingOwnerDetailsRetry__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicOnboardingOwnerDetailsRetry";
  } else {
    func.displayName = `PlasmicOnboardingOwnerDetailsRetry.${nodeName}`;
  }
  return func;
}

export const PlasmicOnboardingOwnerDetailsRetry = Object.assign(
  // Top-level PlasmicOnboardingOwnerDetailsRetry renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    lineStack: makeNodeComponent("lineStack"),
    circle: makeNodeComponent("circle"),
    circle2: makeNodeComponent("circle2"),
    circle3: makeNodeComponent("circle3"),
    circle4: makeNodeComponent("circle4"),
    circle5: makeNodeComponent("circle5"),
    firstName: makeNodeComponent("firstName"),
    lastName: makeNodeComponent("lastName"),
    countrySelect: makeNodeComponent("countrySelect"),
    address1: makeNodeComponent("address1"),
    city: makeNodeComponent("city"),
    selectState: makeNodeComponent("selectState"),
    zip: makeNodeComponent("zip"),
    dob: makeNodeComponent("dob"),
    ssnStack: makeNodeComponent("ssnStack"),
    ssn: makeNodeComponent("ssn"),
    passportStack: makeNodeComponent("passportStack"),
    passport: makeNodeComponent("passport"),
    errorText: makeNodeComponent("errorText"),
    continueButton: makeNodeComponent("continueButton"),
    // Metadata about props expected for PlasmicOnboardingOwnerDetailsRetry
    internalVariantProps: PlasmicOnboardingOwnerDetailsRetry__VariantProps,
    internalArgProps: PlasmicOnboardingOwnerDetailsRetry__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicOnboardingOwnerDetailsRetry;
/* prettier-ignore-end */
